<template lang="html">
  <div class="timespanpicker">
  	<div class="current bold" @click="toggle()" :class="{active: display}">
  		{{ current.label }}
  	</div>
		<div class="values" v-show="display">
			<div class="value bold" v-for="(span, id) in spans" v-bind:key="id" @click="setSelected(id)">
				{{ span.label }}
			</div>
		</div>
  </div>
</template>

<script>
export default {
	name: 'timespanpicker',
	data () {
		return {
			spans: [
				{label: 'JOUR', value: 'day'},
				{label: 'SEMAINE', value: 'week'},
				{label: 'MOIS', value: 'month'},
				{label: 'ANNÉE', value: 'year'},
				{label: 'TOUS', value: 'all'}
			],
			selected: 4,
			display: false
		}
	},
	computed: {
		current () {
			return this.spans[this.selected]
		}
	},
	methods: {
		setSelected (id) {
			this.selected = id
			this.toggle()
			this.$emit('change', this.spans[this.selected].value)
		},
		toggle () {
			this.display = !this.display
		}
	}
}
</script>



// WEBPACK FOOTER //
// timespanpicker.vue?2ae07c47